import { Vehicle } from './vehicle';

/**
 * Paged vehicles/tools response envelope: the rows for the requested
 * `offset`/`limit` window plus the total row count across the whole result
 * set (used to drive server-side pagination — same scheme as the orders list).
 *
 * NOTE: field names mirror the API response. If the backend uses different
 * keys, adjust here and in {@link mapVehiclePage} — those are the only two
 * places that touch the raw envelope shape.
 */
export interface VehiclePage {
  items: Vehicle[];
  totalCount: number;
}

/** Normalizes a raw vehicles response into a {@link VehiclePage}, tolerating a
    bare-array response (no envelope) by treating its length as the total. This
    keeps the frontend working before/after the backend adds the paged envelope. */
export function mapVehiclePage(
  response: VehiclePage | Vehicle[] | null | undefined
): VehiclePage {
  if (Array.isArray(response)) {
    return { items: response, totalCount: response.length };
  }
  return {
    items: response?.items ?? [],
    totalCount: response?.totalCount ?? 0,
  };
}
